export const QUOTES_TAB = 1;
export const REVIEW_TAB = 2;
export const PAY_TAB = 3;
